// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#clinicModeration{max-width:79%}", "",{"version":3,"sources":["webpack://./resources/js/components/dialogs/admin/clinicModeration/Dialog.vue"],"names":[],"mappings":"AACA,kBACI,aAAJ","sourcesContent":["\n#clinicModeration {\n    max-width: 79%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
